.content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.container {
  width: 89.2rem;
}
